import * as types from '@/actions/types'

const initialState = {
  open: false,
  main_menu: [],
  mobile: [],
  extra: [],
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.NAV_SET_OPEN:
      state = {
        ...state,
        open: action.setOpen,
      }
      break
    case types.NAV_SET_COMPACT:
      state = {
        ...state,
        compact: action.setCompact,
      }
      break
    case types.NAV_GET_MAIN:
      state = {
        ...state,
        main_menu: action.data,
      }
      break
    case types.NAV_GET_MOBILE:
      state = {
        ...state,
        mobile: action.data,
      }
      break
    case types.NAV_GET_EXTRA:
      state = {
        ...state,
        extra: action.data,
      }
      break
    case types.NAV_GET_GENERIC:
      state = { ...state, ...action.data }
      break
    default:
      return { ...state }
  }
  return { ...state }
}

export default reducer
